import $ from 'jquery';
import 'slick-carousel';
import { Component } from '../core/component';

export class AboutImageSlider extends Component {
    constructor() {
        super();
        this.selector = '.about-image-slider';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            $(element).find('.about-image-slider__swiper').slick({
                dots: false,
                slidesToShow: 1,
                arrows: true,
                prevArrow: '<button class="slider-prev slick-arrow">'
                    + '<i class="fas fa-chevron-left"></i></button>',
                nextArrow: '<button class="slider-next slick-arrow">'
                    + '<i class="fas fa-chevron-right"></i></button>',
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/aboutImageSlider.js